<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-4">Keagenan - Reporting</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
          <CButtonGroup>
            <CButton color="secondary" @click="handleChooseStatus(1)"
              >Report</CButton
            >
            <CButton color="secondary" @click="handleChooseStatus(2)"
              >Export</CButton
            >
          </CButtonGroup>
        </CCardHeader>

        <page-export v-if="status === 'Export'"></page-export>
        <page-performance v-if="status === 'Performance'"></page-performance>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import Vue from "vue";
import jwt from "jsonwebtoken";
import pageExport from "./page/Export";
import pagePerformance from "./page/Performance";

Vue.component("page-export", pageExport);
Vue.component("page-performance", pagePerformance);

export default {
  name: "Report",
  data() {
    return {
      status: "Performance",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {},

  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "NPOS" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    handleChooseStatus(event) {
      if (event === 1) {
        this.status = "Performance";
      } else if (event === 2) {
        this.status = "Export";
      }
    },
  },
};
</script>
